import React from 'react';
import { storeData } from '../../data/storeData';
import StoreTemplate from '../../components/StoreTemplate';
import grimesImg from '../../assets/images/grimesoutside.jpg';

function Grimes() {
    return <StoreTemplate storeData={storeData.grimes} storeImage={grimesImg} />;
}

export default Grimes; 